import { Controller } from "@hotwired/stimulus"

// registration step の「checkbox 群から最低 1 件以上選択させる」validation controller。
//
// 対象 view (3 instance、Rule of Three 到達で generic 化):
// - work_experience.html.erb
// - work_experience_e.html.erb
// - qualifications.html.erb (#1858 で 2 button instant-submit logic と一緒に migration)
//
// 各 checkbox / submit は target で指定、view 固有の class 名 / id に依存しない。
//
// scope: form を wrap する div または form 自体に置く (checkbox 全部 + submit が subtree)。
//
// XSS 安全性: disabled 切替のみ、innerHTML 不使用。
export default class extends Controller {
  static targets = ["checkbox", "submit"]

  connect() {
    this.update()
  }

  update() {
    const anyChecked = this.checkboxTargets.some((cb) => cb.checked)
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = !anyChecked
    }
  }
}
